import type { SessionBootstrap } from "@/app/api/session/bootstrap/route";

/**
 * Estado pessoal do visitante numa chamada só.
 *
 * Nenhum parâmetro de identidade sai daqui: o CPF vive no cookie httpOnly e é
 * resolvido no servidor. O `storeId` viaja porque o carrinho é por loja — e
 * loja não é segredo.
 */
/**
 * Chave do estado pessoal já carregado. Compartilhada pelo bootstrap e pelos
 * caminhos de recuperação — se cada um montasse a sua, elas divergiriam e a
 * duplicação voltaria sem ninguém notar.
 */
export function sessionKey(cpfCnpj: string | null | undefined, storeId: number): string {
    return `${cpfCnpj ?? "anon"}:${storeId}`;
}

/** true quando a chave é de visitante sem conta. */
export function isAnonymousKey(key: string): boolean {
    return key.startsWith("anon:");
}

export async function fetchSessionBootstrap(storeId?: number): Promise<SessionBootstrap | null> {
    try {
        const query = storeId ? `?storeId=${storeId}` : "";
        const response = await fetch(`/api/session/bootstrap${query}`, { cache: "no-store" });
        if (!response.ok) return null;
        return (await response.json()) as SessionBootstrap;
    } catch {
        return null;
    }
}

export type { SessionBootstrap };
